module.exports = __webpack_public_path__ + "img/price-settings-icon.c1030c97.svg";